module.exports = __webpack_public_path__ + "img/file-02.9918c408.svg";